import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '../../components/Button/Button';
import Card from '../../components/Card/Card';

const PaymentFailure = () => {
  return (
    <div className="w-full flex flex-col gap-11">
      <Card>
        <div className="grid grid-flow-col grid-rows-1 grid-cols-2 gap-10 px-14">
          <div className="flex flex-col items-center">
            <img
              src={require('../../assets/images/payment fail.svg').default}
              alt=""
              className="max-h-[355px] h-[355px] object-contain min-w-[300px]"
            />
          </div>
          <div className="flex justify-center items-center">
            <div className="flex flex-col gap-6 justify-center items-center">
              <h1 className="text-left font-bold text-[25px] leading-[34px]">
                Sorry! But the payment failed
              </h1>
              <p className="text-left text-sm pt-4 font-normal">
                Your policy has not been booked! This might be due to payment
                failure
              </p>
              <div className="text-sm">
                <div className="flex flex-col gap-[21px] justify-center items-start">
                  <p className="font-bold">
                    <span>Quotation Number:</span>
                    <span>EIBLMTRPC2022082211443612</span>
                  </p>
                  {[
                    { label: 'Transaction Number', value: 'GS4YTCFBS344' },
                    { label: 'Policy Number', value: '565/5654/000/01' },
                    { label: 'Proposal Number', value: 'P/NO/4646/354543645' },
                    { label: 'Your Premium', value: '54364' },
                    { label: 'Status', value: 'Failed' },
                    {
                      label: 'Message',
                      value: 'Money deducted but policy not booked',
                    },
                  ].map((item, i) => {
                    return (
                      <p className="text-sm">
                        <span className="after:inline-block after:content-[':'] after:mr-2 text-sm font-bold">
                          {item.label}
                        </span>
                        <span>{item.value}</span>
                      </p>
                    );
                  })}
                </div>
              </div>
              <div className="flex gap-4">
                <Button size={'medium'}>Proceed to Home</Button>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* <DevTool control={control} /> */}
    </div>
  );
};

export default PaymentFailure;
